import cx from "classnames";

import MainNavigationNavigationItem from "components/MainNavigation/components/elements/NavigationItem";
import Box from "ds/components/Box";

import usePinnedGroup from "../../../config/usePinnedGroup";
import useMainNavigationPinnedItems from "../../../hooks/usePinnedItems";
import useMainNavigationPinnedHighlight from "../../../hooks/usePinnedHighlight";
import MainNavigationPinnedItemsEmptyState from "./EmptyState";
import styles from "./styles.module.css";

const MainNavigationPinnedGroup = () => {
  const pinnedItems = useMainNavigationPinnedItems();
  const isHighlighted = useMainNavigationPinnedHighlight(pinnedItems.length);
  const pinnedGroup = usePinnedGroup(pinnedItems);

  return (
    <Box
      className={cx(styles.pinnedGroupHighlight, {
        [styles.pulse]: isHighlighted,
      })}
    >
      <MainNavigationNavigationItem
        item={pinnedGroup}
        emptyState={<MainNavigationPinnedItemsEmptyState />}
      />
    </Box>
  );
};

export default MainNavigationPinnedGroup;
